<template>
  <div class="box">
    <div class="title">
         督办内容
    </div>
    <div class="about_content">
        <textarea class="content" placeholder="最多不能超多40个字..." maxlength="40" v-model="remark" @input="change"></textarea>
        <span class="total">{{currentTotal}}/40</span>
    </div>
    <div class="confirm" @click="send">提交</div>
    <div class="confirm cancel" @click="goBack">取消</div>
    <!-- <div class="box2">
      <div class="remark">
        <div class="titleName">督办内容</div>
        <div class="notAccepted">
          <van-field placeholder="最多不能超多40个字..." type="textarea" maxlength="40" v-model="remark" @input="change"/>
          <span class="total">{{currentTotal}}/40</span>
        </div>
      </div>
      <div class="btn">
        <div class="submit" @click="send">
            <van-button type="primary">提交</van-button>
        </div>
        <div class="back"  @click="goBack">
            <van-button plain type="default" color="#979595">返回</van-button>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/complaintApis';
    export default {
        data () {
            return {
                remark: '',
                currentTotal: 0,
                itemList: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                falg: false
            }
        },
        created () {

        },
        methods: {
            change () {
                this.remark = this.remark.replace(" ","");
                this.currentTotal = this.remark.trim().length;
            },
            send () {
                if (this.remark.trim().length === 0) {
                    this.$Toast('请填写督办内容');
                    return;
                }
                const params = {
                  "mainComplainNumber": this.itemList.mainComplainNumber,
                  "complainNumber": this.itemList.complainNumber,
                  "subId": this.itemList.subId,
                  "content": this.remark.trim()
                }
                if (this.falg === false) {
                  this.falg = true;
                  api.worker.supervise(params).then((res) => {
                      if (res.ret === 0) {
                          this.$Toast('操作成功');
                          this.$router.back();
                          // if(!this.isback){
                          //     this.$router.go(-2);
                          //   }else{
                          //       this.$router.back();
                          //       this.$set(this.itemList,'btns',[]);
                          //       util.setJsonLocal('item',this.itemList);
                          //   }
                      }
                  })
                }
            },
            goBack () {
                this.$router.go(-1)
            }
        }
    };
</script>
<style lang="less" scoped>
// .box {
//   width: 100%;
//   padding: 14px;
//   background-color: #f4f3f3;
//   box-sizing: border-box;
//   height: 100%;
//   .box2 {
//     width: 100%;
//     padding: 14px;
//     background-color: #fff;
//     font-size: 14px;
//     box-sizing: border-box;
//     .remark {
//       width: 100%;
//       padding-bottom: 20px;
//       .titleName {
//         color: #aaa;
//         text-align: left;
//       }
//       .notAccepted {
//         margin-top: 14px;
//         position: relative;
//         .van-cell {
//           font-size: 14px;
//           background: #efeded;
//           border-radius: 7px;
//         }
//         .total{
//           position: absolute;
//           bottom:6px;
//           right:6px;
//         }
//       }
//       .addCommandCenter {
//           width: 70%;
//           margin-left: 15%;
//           font-size: 14px;
//           height: 45px;
//           line-height: 45px;
//           color: #bbb;
//           border: #ccc dashed 1px;
//           text-align: center;
//           margin-top: 15px;
//       }
//     }
//     .companyName {
//       height: 50px;
//       line-height: 50px;
//     }
//     .emergencyLevel {
//       width: 100%;
//       height: 50px;
//       line-height: 50px;
//     }
//     .btn {
//       margin-top: 14px;
//       .van-button {
//         width: 100%;
//         border-radius: 7px;
//       }
//       .back {
//         margin-top: 10px;
//         .van-button {
//           color: #bdb8b8;
//         }
//         .van-button--plain {
//           background-color: #efeded;
//         }
//       }
//     }
//     .border_bottom {
//       border-bottom: 1px solid #eee;
//     }
//   }
// }
.box{
  width:100%;
  background-color: #fff;
  padding:0 12px;
  box-sizing: border-box;
  .title{
    width:100%;
    font-size:16px;
    padding-top:20px;
    color:#333;
  }
  .about_content{
     width:100%;
     height:180px;
     margin-top:20px;
     position: relative;
     .content{
       width:100%;
       height:100%;
       font-size:14px;
       color:#666;
       background-color: #F9F9F9;
       border:0;
       outline: none;
       border-radius: 3px;
       padding:16px;
       box-sizing: border-box;
       line-height: 1.3em;
    }
    .total{
       position: absolute;
       bottom:8px;
       right:8px;
       font-size:14px;
       color:#999;
    }
  }
  .confirm{
      width:350px;
      height:50px;
      text-align: center;
      line-height: 50px;
      color:#fff;
      font-size:16px;
      background-color: @base-color;
      // position: fixed;
      // left:12px;
      // bottom:60px;
      border-radius: 3px;
      margin-top:16px;
  }
  .cancel{
    background-color: #fff;
    border:1px solid @base-color;
    color:@base-color;
    // color:@base-color;
  }
}
</style>
